 "use client";

import React, { useEffect, useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { Btn } from '../../../AbstractElements';
import { FaPlus, FaEdit, FaTrash, FaEye } from "react-icons/fa"
import StandCategoryService from '../../../Service/StandCategoryService';
import { StandCategory } from './types';

interface Props {
  onAdd: () => void;
  onEdit: (item: StandCategory) => void;
  refresh: boolean;
}

const StandCategoryList: React.FC<Props> = ({ onAdd, onEdit, refresh }) => {
  const [data, setData] = useState<StandCategory[]>([]);

  const fetchData = async () => {
    try {
      const response = await StandCategoryService.getAll();
      setData(response.results); 
    } catch (err) {
      console.error('Failed to fetch stand Categories:', err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [refresh]);

  const columns = [
    {
      name: 'Name',
      selector: (row: StandCategory) => row.name,
      sortable: true,
    },
    {
      name: 'Badges',
      selector: (row: StandCategory) => row.num_representatives,
      sortable: true,
    },
    {
      name: 'Cars',
      selector: (row: StandCategory) => row.num_cars,
      sortable: true,
    },
    {
      name: 'Status',
      selector: (row: StandCategory) => (row.status ? 'Active' : 'Not Active'),
      sortable: true,
    },
    {
      name: 'Actions',
      cell: (row: StandCategory) => (
        <>
         

          <Btn color="info" className='me-2' size="xs" onClick={() => onEdit(row)} title="Edit">
                      <FaEdit size={12} />
                    </Btn>
                    <Btn color="danger" size="xs" onClick={async () => {
              await StandCategoryService.delete(row.id);
              fetchData(); 
            }} title="Delete">
                      <FaTrash size={12} />
                    </Btn>
        </>
      ),
    },
  ];

  return (
    <Card>
      <CardBody>
        <div className="d-flex justify-content-end mb-3">
          <Btn color="primary" onClick={onAdd}>
            Add Stand Category
          </Btn>
        </div>
        <DataTable
          columns={columns}
          data={data}
          pagination
          highlightOnHover
          striped
        />
      </CardBody>
    </Card>
  );
};

export default StandCategoryList;
